import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { getMapperDetailRows } from '../../utils/mapperFields';

const labelSx = {
  fontFamily: 'Metropolis, sans-serif',
  fontSize: '0.75rem',
  color: '#666666',
  flexShrink: 0,
  width: 200,
  pt: '2px',
};

const valueSx = {
  fontFamily: 'Metropolis, sans-serif',
  fontSize: '0.8rem',
  color: '#253E66',
  wordBreak: 'break-word',
};

const booleanChipSx = (on) => ({
  height: 20,
  fontSize: '0.68rem',
  fontFamily: 'Metropolis, sans-serif',
  fontWeight: 600,
  backgroundColor: on ? '#F0F9F4' : '#F2F2F2',
  color: on ? '#27AE60' : '#999999',
});

const renderValue = ({ value, kind }) => {
  if (kind === 'boolean') {
    return <Chip label={value ? 'On' : 'Off'} size="small" sx={booleanChipSx(value)} />;
  }
  return <Typography sx={valueSx}>{value}</Typography>;
};

/** Read-only detail grid for a single Keycloak protocol mapper. */
const MapperDetails = ({ mapper }) => {
  const rows = getMapperDetailRows(mapper);

  if (rows.length === 0) {
    return (
      <Typography sx={{ ...valueSx, color: '#BBBBBB' }}>No configuration</Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
      {rows.map((row) => (
        <Box key={row.label} sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <Typography sx={labelSx}>{row.label}</Typography>
          <Box sx={{ minWidth: 0, flex: 1 }}>{renderValue(row)}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default MapperDetails;
